import {connect, MapDispatchToProps, MapStateToProps} from "react-redux";
import {State} from "../../store/rootReducers";
import DifferenceListSidebar, {
    IDifferenceListSidebarDispatchProps,
    IDifferenceListSidebarStateProps
} from "./DifferenceListSidebar";
import {
    deleteUnrecognizedPackagesImages,
    setDetailedDiff, setDifferenceAllStatus,
    setDifferenceData,
    setDifferenceStatus,
    setIsChangingDetailedDiff,
    setIsTrackDisabled,
    setLeftScale,
    setMenuOpen,
    setRightScale,
} from "../../ducks/montitoring";
import {popupPush} from "../../ducks/popup";
import {routeTo} from "../../ducks/baseCRUD";
import {sendTechnicalReport, setComment, updateTechReportText} from "../../ducks/upload";
import {
    selectDetailedDiff, selectDetailedPair,
    selectDifferenceBarPosition,
    selectDifferenceData,
    selectDocFilterList,
    selectFirstDocumentPosition,
    selectIsChangingDetailedDiff,
    selectIsChangingView,
    selectMenuOpen
} from "../../selectors/monitoring";
import {selectUrlId} from "../../selectors/other";
import {selectComment} from "../../selectors/upload";

const mapStateToProps: MapStateToProps<IDifferenceListSidebarStateProps, {}, State> = state => {
    const detailedDiff = selectDetailedDiff(state);
    const panelPosition = selectDifferenceBarPosition(state);
    const docPosition = selectFirstDocumentPosition(state);
    const menuOpen = selectMenuOpen(state);
    const urlId = selectUrlId(state);
    const comment = selectComment(state);
    const detailedPair = selectDetailedPair(state);
    const differenceData =  selectDifferenceData(state);
    const docFilterList = selectDocFilterList(state);
    const filteredDiscrepancyCount = differenceData?.reduce((acc, el) => {
        const hide = el.discrepancyElements && el.discrepancyElements.length > 0 && el.discrepancyElements.filter(discrepancy => docFilterList.includes(discrepancy)).length === 0;
        if(hide) return acc + 1;
        return acc;
    }, 0);

    return {
        barWidth: menuOpen ? 300 : 59,
        urlId,
        docFilterList: selectDocFilterList(state),
        isChangingView: selectIsChangingView(state),
        differenceData,
        detailedDiff,
        menuOpen: menuOpen,
        panelPosition,
        docPosition,
        discrepancyRatio: detailedPair?.discrepancyRatio ?? 0,
        comment,
        filteredDiscrepancyCount,
    }
};

const dispatchProps: MapDispatchToProps<IDifferenceListSidebarDispatchProps, {}> = {
    setDetailedDiff,
    popupPush,
    routeTo: (route, id?) => {
        return routeTo(route, id)
    },
    setDifferenceStatus,
    setLeftScale,
    setRightScale,
    setIsTrackDisabled,
    deleteUnrecognizedPackagesImages,
    sendTechnicalReport,
    updateTechReportText,
    setDifferenceData,
    setMenuOpen,
    setComment,
    setDifferenceAllStatus,

};

export const DifferenceListSidebarConnected = connect(
    mapStateToProps,
    dispatchProps,
)(DifferenceListSidebar);
